const defaultState = {
  billingAccounts: [],
  billingUsers: [],
  date: { from: null, until: null },
  invoices: [],
  totalInvoices: 0
};

export default defaultState;
